export type ISaveAppToken = ReturnType<typeof saveAppToken>;
export const saveAppToken = (orgSlug: string, appToken: string) => ({
  type: 'appTokens/saveAppToken' as const,
  payload: { orgSlug, appToken },
});
